import styled from '@emotion/styled';
import { BodyLarge, Row, TitleMedium, TitleSmall } from '../../styles';
import { Box } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { Breakpoint, isCompact } from '../../types';

const ProjectTableRow = styled(Box)`
    display: grid;
    grid-template-columns: 3fr 2fr 48px;
    background-color: ${({ theme }) => theme.colors.surface};
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    padding: ${({ theme }) => theme.spacing(2)};
    cursor: pointer;
    align-items: center;
`;

const ProjectTableRowSmall = styled(Box, shouldForwardProps)<{
    breakpoint: Breakpoint;
}>`
    background-color: ${({ theme }) => theme.colors.surface};
    border-radius: ${({ breakpoint }) => (isCompact(breakpoint) ? '0px' : '12px')};
    padding: ${({ theme }) => theme.spacing(2)};
    padding-top: ${({ theme }) => theme.spacing(3)};
    cursor: pointer;
    position: relative;
`;

const LoadingProjectTableRow = styled(ProjectTableRow)`
    height: 80px;
    cursor: default;
`;

const LoadingBlocksAligned = styled(Row)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const ProjectTitleSmall = styled(TitleSmall)`
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
`;

const ProjectTitleMedium = styled(TitleMedium)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
`;

const CreatorName = styled(BodyLarge)`
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
`;

const ActionBar = styled(Row)`
    position: absolute;
    top: 0;
    right: 0;
`;

export {
    ProjectTableRow,
    ProjectTableRowSmall,
    ProjectTitleMedium,
    LoadingProjectTableRow,
    ProjectTitleSmall,
    LoadingBlocksAligned,
    CreatorName,
    ActionBar
};
